// Mock data — TER Grand Est clone of labetaillere.fr
// Will be replaced by SNCF Open Data API (Navitia) in backend phase

export const STATIONS = [
  { id: 'FRMZM', name: 'Metz', region: 'Moselle' },
  { id: 'FRXSG', name: 'Strasbourg', region: 'Bas-Rhin' },
  { id: 'FRNCY', name: 'Nancy', region: 'Meurthe-et-Moselle' },
  { id: 'FRRMS', name: 'Reims', region: 'Marne' },
  { id: 'FRMLH', name: 'Mulhouse', region: 'Haut-Rhin' },
  { id: 'FRCMR', name: 'Colmar', region: 'Haut-Rhin' },
  { id: 'FRTHV', name: 'Thionville', region: 'Moselle' },
  { id: 'FREPN', name: 'Épinal', region: 'Vosges' },
  { id: 'FRCMZ', name: 'Charleville-Mézières', region: 'Ardennes' },
  { id: 'FRSGM', name: 'Sarreguemines', region: 'Moselle' },
  { id: 'FRSDV', name: 'Saint-Dié-des-Vosges', region: 'Vosges' },
  { id: 'FRBLD', name: 'Bar-le-Duc', region: 'Meuse' },
  { id: 'FRVRD', name: 'Verdun', region: 'Meuse' },
  { id: 'FRFRB', name: 'Forbach', region: 'Moselle' },
  { id: 'FRCLS', name: 'Châlons-en-Champagne', region: 'Marne' },
  { id: 'FRTRY', name: 'Troyes', region: 'Aube' },
  { id: 'FRSDN', name: 'Sedan', region: 'Ardennes' },
  { id: 'FRHGN', name: 'Haguenau', region: 'Bas-Rhin' },
  { id: 'FRSVN', name: 'Saverne', region: 'Bas-Rhin' },
  { id: 'FRLUN', name: 'Lunéville', region: 'Meurthe-et-Moselle' },
  { id: 'FRPAM', name: 'Pont-à-Mousson', region: 'Meurthe-et-Moselle' },
  { id: 'FRHGD', name: 'Hagondange', region: 'Moselle' },
  { id: 'FRSLT', name: 'Sélestat', region: 'Bas-Rhin' },
  { id: 'FRBFT', name: 'Belfort', region: 'Territoire de Belfort' },
  { id: 'FRVSL', name: 'Vesoul', region: 'Haute-Saône' },
  { id: 'FRLUX', name: 'Luxembourg', region: 'Luxembourg' },
  { id: 'FRBTB', name: 'Bettembourg', region: 'Luxembourg' },
  { id: 'FRWPY', name: 'Woippy', region: 'Moselle' },
  { id: 'FRMNN', name: 'Metz Nord', region: 'Moselle' },
  { id: 'FRUKG', name: 'Uckange', region: 'Moselle' }
];

const now = new Date();
const pad = (n) => String(n).padStart(2, '0');
const plus = (mins) => {
  const d = new Date(now.getTime() + mins * 60000);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Simple deterministic seed based on station name
const seedFromName = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return h;
};
const mulberry32 = (a) => () => {
  let t = (a += 0x6D2B79F5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

// Curated lines per major Grand Est station — what departs from there
const STATION_LINES = {
  'Strasbourg':   ['Mulhouse','Colmar','Sélestat','Saverne','Sarrebourg','Haguenau','Saint-Louis','Metz','Nancy','Paris-Est'],
  'Metz':         ['Luxembourg','Nancy','Thionville','Strasbourg','Forbach','Sarreguemines','Hagondange','Reims','Paris-Est'],
  'Nancy':        ['Metz','Luxembourg','Épinal','Lunéville','Saint-Dié-des-Vosges','Pont-à-Mousson','Strasbourg','Paris-Est'],
  'Reims':        ['Châlons-en-Champagne','Charleville-Mézières','Sedan','Épernay','Paris-Est','Bar-le-Duc'],
  'Mulhouse':     ['Strasbourg','Colmar','Belfort','Saint-Louis','Bâle','Sélestat'],
  'Colmar':       ['Strasbourg','Mulhouse','Sélestat','Metzeral','Munster'],
  'Thionville':   ['Luxembourg','Metz','Hagondange','Bettembourg','Uckange','Hettange-Grande'],
  'Épinal':       ['Nancy','Remiremont','Saint-Dié-des-Vosges','Lunéville','Belfort'],
  'Charleville-Mézières': ['Reims','Sedan','Givet','Paris-Est'],
  'Sarreguemines': ['Metz','Forbach','Strasbourg','Sarrebruck'],
  'Saint-Dié-des-Vosges': ['Nancy','Épinal','Strasbourg'],
  'Bar-le-Duc':   ['Châlons-en-Champagne','Reims','Verdun','Paris-Est'],
  'Verdun':       ['Bar-le-Duc','Conflans-Jarny','Metz'],
  'Forbach':      ['Metz','Sarreguemines','Sarrebruck'],
  'Châlons-en-Champagne': ['Reims','Bar-le-Duc','Épernay','Paris-Est'],
  'Troyes':       ['Paris-Est','Belfort','Mulhouse','Vesoul'],
  'Sedan':        ['Reims','Charleville-Mézières'],
  'Haguenau':     ['Strasbourg','Niederbronn-les-Bains','Wissembourg'],
  'Saverne':      ['Strasbourg','Sarrebourg','Metz'],
  'Lunéville':    ['Nancy','Strasbourg','Saint-Dié-des-Vosges'],
  'Pont-à-Mousson': ['Nancy','Metz','Pagny-sur-Moselle'],
  'Hagondange':   ['Metz','Thionville','Luxembourg','Nancy'],
  'Sélestat':     ['Strasbourg','Colmar','Mulhouse'],
  'Belfort':      ['Mulhouse','Vesoul','Épinal','Besançon'],
  'Vesoul':       ['Belfort','Besançon','Nancy'],
  'Luxembourg':   ['Bettembourg','Thionville','Metz','Nancy'],
  'Bettembourg':  ['Luxembourg','Thionville','Metz'],
  'Woippy':       ['Metz','Thionville'],
  'Metz Nord':    ['Metz','Hagondange','Thionville'],
  'Uckange':      ['Hagondange','Thionville','Metz']
};

const TYPES_POOL = ['TER','TER','TER','TER','RE','RE','TGV','IC'];
const COMP_POOL = ['US3','US3','UM6','UM','US5'];

const generateBoardForStation = (stationName) => {
  const seed = seedFromName(stationName);
  const rand = mulberry32(seed);
  const dests = STATION_LINES[stationName] || ['Strasbourg','Metz','Nancy','Reims'];

  const baseTrainNumber = 80000 + (seed % 9000);

  const mkDeparture = (i) => {
    const r = rand();
    const offset = 3 + i * 6 + Math.floor(r * 4);
    const status = r < 0.65 ? 'on_time' : r < 0.88 ? 'delayed' : 'cancelled';
    const delay = status === 'delayed' ? Math.floor(rand() * 25) + 3 : 0;
    const type = TYPES_POOL[Math.floor(rand() * TYPES_POOL.length)];
    const trainNum = String(baseTrainNumber + i * 7 + Math.floor(rand() * 5));
    const dest = dests[i % dests.length];
    const allVia = dests.filter(d => d !== dest);
    const via = allVia.slice(0, 2 + Math.floor(rand() * 2));
    const platform = status === 'cancelled' ? '—' : String(1 + Math.floor(rand() * 12));
    return {
      id: trainNum + '-' + i,
      type,
      number: type === 'TGV' ? 'TGV ' + (9800 + Math.floor(rand() * 80)) : trainNum,
      time: plus(offset),
      realTime: status === 'cancelled' ? '—' : plus(offset + delay),
      delay,
      destination: dest,
      via,
      platform,
      status,
      composition: status === 'cancelled' ? '—' : COMP_POOL[Math.floor(rand() * COMP_POOL.length)],
      occupancy: status === 'cancelled' ? 0 : 30 + Math.floor(rand() * 65)
    };
  };

  const mkArrival = (i) => {
    const r = rand();
    const offset = 2 + i * 7 + Math.floor(r * 4);
    const status = r < 0.7 ? 'on_time' : r < 0.92 ? 'delayed' : 'cancelled';
    const delay = status === 'delayed' ? Math.floor(rand() * 20) + 3 : 0;
    const type = TYPES_POOL[Math.floor(rand() * TYPES_POOL.length)];
    const trainNum = String(baseTrainNumber + 5000 + i * 5);
    const origin = dests[(i + 1) % dests.length];
    const platform = status === 'cancelled' ? '—' : String(1 + Math.floor(rand() * 12));
    return {
      id: trainNum + '-a' + i,
      type,
      number: type === 'TGV' ? 'TGV ' + (9700 + Math.floor(rand() * 80)) : trainNum,
      time: plus(offset),
      realTime: status === 'cancelled' ? '—' : plus(offset + delay),
      delay,
      origin,
      platform,
      status
    };
  };

  const departures = Array.from({ length: 10 }, (_, i) => mkDeparture(i)).sort((a, b) => a.time.localeCompare(b.time));
  const arrivals = Array.from({ length: 7 }, (_, i) => mkArrival(i)).sort((a, b) => a.time.localeCompare(b.time));

  return {
    station: stationName,
    updated: new Date().toISOString(),
    weather: {
      temp: 6 + Math.floor(rand() * 18),
      icon: 'cloud',
      humidity: 40 + Math.floor(rand() * 50),
      wind: 4 + Math.floor(rand() * 22)
    },
    departures,
    arrivals
  };
};

export const generateBoard = (stationName) => generateBoardForStation(stationName);

export const TRAIN_TYPES = {
  TER: { code: 'Fluo', label: 'Fluo Grand Est (TER)', color: '#191998' },
  TGV: { code: 'TGV', label: 'TGV inOui', color: '#9F2241' },
  IC: { code: 'IC', label: 'Intercités', color: '#0078A8' },
  RE: { code: 'RE', label: 'RE — Régional Express', color: '#E2001A' }
};

// Train composition data — see getComposition() below for runtime logic

export const SERVICE_INFO = [
  { line: 'Metz ↔ Luxembourg', status: 'major', label: 'Trafic très perturbé', detail: 'Régulation des circulations à Bettembourg.' },
  { line: 'Nancy ↔ Metz', status: 'minor', label: 'Trafic perturbé', detail: 'Travaux entre Pagny-sur-Moselle et Frouard.' },
  { line: 'Strasbourg ↔ Sarreguemines', status: 'normal', label: 'Trafic normal', detail: 'Aucune perturbation signalée.' },
  { line: 'Reims ↔ Châlons-en-Champagne', status: 'normal', label: 'Trafic normal', detail: 'Aucune perturbation signalée.' }
];

// ---------------------------------------------------------------------------
// Deterministic mock composition generator (per train number)
// Will be REPLACED by SNCF Open Data / référentiel matériel roulant when
// the official feed is granted. Same train number → same composition.
// ---------------------------------------------------------------------------

const ROLLING_STOCK = [
  { type: 'Régio2N (Z 55500)',     layout: 'US3', wagons: 6, seatsPerCoach: [86, 88, 56, 96, 104, 89] },
  { type: 'Régiolis (Z 31500)',    layout: 'US3', wagons: 4, seatsPerCoach: [80, 60, 80, 60] },
  { type: 'Régiolis (B 84500) Bi-mode', layout: 'US4', wagons: 4, seatsPerCoach: [78, 58, 78, 58] },
  { type: 'BiBi (B 82500)',        layout: 'UM6', wagons: 4, seatsPerCoach: [60, 50, 56, 54] },
  { type: 'TER 2N NG (Z 24500)',   layout: 'UM6', wagons: 5, seatsPerCoach: [104, 80, 60, 95, 90] },
  { type: 'Corail TER Fluo',       layout: 'UM',  wagons: 9, seatsPerCoach: [78, 78, 78, 78, 78, 78, 78, 78, 78] },
  { type: 'Régiolis Z 31500 (UM)', layout: 'UM6', wagons: 6, seatsPerCoach: [80, 60, 80, 80, 60, 80] },
  { type: 'TGV Réseau',            layout: 'UM',  wagons: 8, seatsPerCoach: [42, 60, 60, 50, 50, 60, 60, 42] }
];

const getCompositionFor = (trainNumber) => {
  const num = String(trainNumber || '').trim();
  if (!num) return null;

  // Deterministic seed from train number
  let seed = 0;
  for (let i = 0; i < num.length; i++) seed = (seed * 31 + num.charCodeAt(i)) >>> 0;
  const rand = (() => {
    let s = seed || 1;
    return () => {
      s = Math.imul(s ^ (s >>> 15), s | 1);
      s ^= s + Math.imul(s ^ (s >>> 7), s | 61);
      return ((s ^ (s >>> 14)) >>> 0) / 4294967296;
    };
  })();

  // Heuristic: TGV numbers (4-digit < 10000) → TGV; numbers starting with 9 → Corail; else random TER stock
  let stockIdx;
  const n4 = parseInt(num, 10);
  if (!Number.isNaN(n4) && n4 < 10000 && (num.startsWith('9') || num.startsWith('6'))) {
    stockIdx = 7; // TGV
  } else if (num.length >= 5 && num.startsWith('96')) {
    stockIdx = 5; // Corail
  } else {
    stockIdx = Math.floor(rand() * 6); // any TER stock
  }
  const stock = ROLLING_STOCK[stockIdx];

  // Build coaches with classes & options
  const coaches = stock.seatsPerCoach.map((seats, i) => {
    const isFirst = i === 0;
    const isLast = i === stock.seatsPerCoach.length - 1;
    let cls = '2';
    if (i === 1 && stock.wagons >= 4) cls = '1/2';
    if (i === 2 && stock.wagons >= 5) cls = '1';
    return {
      num: i + 1,
      class: cls,
      seats,
      pmr: i === 0 || (isLast && stock.wagons >= 5),
      bike: i === 0 || isLast,
      occupancy: 30 + Math.floor(rand() * 65)
    };
  });

  const totalSeats = coaches.reduce((s, c) => s + c.seats, 0);
  return {
    type: stock.type,
    wagonsCount: stock.wagons,
    totalSeats,
    layout: stock.layout,
    coaches
  };
};

// Static overrides for trains where we know the real composition
const STATIC_COMPOSITIONS = {
  '88501': {
    type: 'Régio2N (Z 55500)', wagonsCount: 6, totalSeats: 519, layout: 'US3',
    coaches: [
      { num: 1, class: '2',   seats: 86,  pmr: true,  bike: true,  occupancy: 65 },
      { num: 2, class: '2',   seats: 88,  pmr: false, bike: false, occupancy: 72 },
      { num: 3, class: '1',   seats: 56,  pmr: false, bike: false, occupancy: 45 },
      { num: 4, class: '1/2', seats: 96,  pmr: false, bike: false, occupancy: 80 },
      { num: 5, class: '2',   seats: 104, pmr: false, bike: false, occupancy: 90 },
      { num: 6, class: '2',   seats: 89,  pmr: true,  bike: false, occupancy: 85 }
    ]
  },
  '96227': {
    type: 'Corail TER Fluo', wagonsCount: 9, totalSeats: 702, layout: 'UM',
    coaches: [
      { num: 1, class: '2',   seats: 78, pmr: true,  bike: true,  occupancy: 55 },
      { num: 2, class: '2',   seats: 78, pmr: false, bike: false, occupancy: 62 },
      { num: 3, class: '2',   seats: 78, pmr: false, bike: false, occupancy: 70 },
      { num: 4, class: '1/2', seats: 78, pmr: false, bike: false, occupancy: 60 },
      { num: 5, class: '1',   seats: 78, pmr: false, bike: false, occupancy: 50 },
      { num: 6, class: '2',   seats: 78, pmr: false, bike: false, occupancy: 75 },
      { num: 7, class: '2',   seats: 78, pmr: false, bike: false, occupancy: 80 },
      { num: 8, class: '2',   seats: 78, pmr: false, bike: false, occupancy: 78 },
      { num: 9, class: '2',   seats: 78, pmr: true,  bike: true,  occupancy: 65 }
    ]
  }
};

/**
 * Returns composition for a given train number.
 * - First checks STATIC_COMPOSITIONS (real-known cases)
 * - Falls back to deterministic generation
 * - Returns null only for empty/invalid input
 */
export const getComposition = (trainNumber) => {
  if (!trainNumber) return null;
  const key = String(trainNumber).trim();
  // Car Fluo ranges — no mock train composition applies
  const n = parseInt(key, 10);
  if (!isNaN(n) && ((n >= 43000 && n <= 45999) || (n >= 427000 && n <= 435999))) {
    return null;
  }
  if (STATIC_COMPOSITIONS[key]) return STATIC_COMPOSITIONS[key];
  return getCompositionFor(key);
};

// Backwards-compat: legacy COMPOSITIONS map (used elsewhere)
export const COMPOSITIONS = STATIC_COMPOSITIONS;
